import { useQueryClient } from '@tanstack/react-query';

import { type AutoshipContent } from '../api';
import { AUTOSHIP_CONTENT_KEY, AUTOSHIP_MAP_RESTRICTED_CONTENT_KEY } from './queryKey';

export type UseAutoshipContentQueryResult = {
    autoshipContent: AutoshipContent | undefined;
    autoshipMapRestrictedContent: AutoshipContent | undefined;
};

export const useAutoshipContentQuery = (): UseAutoshipContentQueryResult => {
    const queryClient = useQueryClient();

    const autoshipContent: AutoshipContent | undefined = queryClient.getQueryData([AUTOSHIP_CONTENT_KEY]);
    const autoshipMapRestrictedContent: AutoshipContent | undefined = queryClient.getQueryData([
        AUTOSHIP_MAP_RESTRICTED_CONTENT_KEY,
    ]);

    return { autoshipContent, autoshipMapRestrictedContent };
};
